import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './dialog';
import { Button } from './button';

interface EmojiPickerProps {
  isOpen: boolean;
  onClose: () => void;
  onEmojiSelect?: (emoji: string) => void;
  onSelect?: (emoji: string) => void;
}

const emojis = [
  '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇',
  '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚',
  '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩',
  '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣',
  '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬',
  '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓', '🤗',
  '🤔', '🤭', '🤫', '🤥', '😶', '😐', '😑', '😬', '🙄', '😯',
  '😦', '😧', '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '🤐',
  '🥴', '🤢', '🤮', '🤧', '😷', '🤒', '🤕', '🤑', '🤠', '😈',
  '👿', '👹', '👺', '🤡', '💩', '👻', '💀', '☠️', '👽', '👾',
  '🤖', '🎃', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿',
  '😾', '❤️', '🧡', '💛', '💚', '💙', '💜', '🤎', '🖤', '🤍'
];

export function EmojiPicker({ isOpen, onClose, onEmojiSelect, onSelect }: EmojiPickerProps) {
  const handleSelect = (emoji: string) => {
    onEmojiSelect?.(emoji);
    onSelect?.(emoji);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl w-full mx-4 p-8 bg-gradient-to-br from-white via-yellow-50/40 to-orange-50/30 backdrop-blur-xl border-0 shadow-2xl rounded-3xl">
        <DialogHeader className="text-center space-y-3 pb-6">
          <DialogTitle className="text-2xl font-bold bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 bg-clip-text text-transparent">
            Choose an Emoji
          </DialogTitle>
          <p className="text-gray-600">Express yourself with the perfect emoji</p>
        </DialogHeader>
        <div className="bg-white/80 rounded-2xl p-6 backdrop-blur-sm border border-white/20 shadow-lg">
          <div className="grid grid-cols-12 md:grid-cols-16 lg:grid-cols-20 gap-3 max-h-80 overflow-y-auto p-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
            {emojis.map((emoji, index) => (
              <Button
                key={index}
                variant="ghost"
                className="h-12 w-12 p-0 text-2xl hover:bg-gradient-to-br hover:from-yellow-100 hover:to-orange-100 hover:scale-110 transition-all duration-200 rounded-xl border-2 border-transparent hover:border-yellow-200 hover:shadow-lg"
                onClick={() => {
                  handleSelect(emoji);
                  onClose();
                }}
              >
                {emoji}
              </Button>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}